import Vuex from 'vuex';
import { CarTypes, RimTypes } from '@/utils/constants';
import { formatPercentage } from '@/utils/utils';

// state
function createState(address, strings, enums, settings, confirmationText, images) {
    var res = {
        //offer parameters
        selectedStationId: null,
        selectedTyre: null,
        tyreAmount: 4,
        rimType: RimTypes.Aluminium,
        carType: CarTypes.PKW,
        remarks: '',
        dseAccepted: false,

        //address
        salutation: '',
        firstName: '',
        lastName: '',
        companyName: '',
        street: '',
        streetNumber: '',
        addressLine2: '',
        zipcode: '',
        city: '',
        phone: '',
        emailAddress: '',

        //server side properties
        strings: strings,
        enums: enums,
        settings: settings,
        confirmationText: confirmationText,
        images: images,

        //step 1 things
        seasonFilter: null,
        widthFilter: null,
        heightFilter: null,
        rimSizeFilter: null,
        brandFilter: null,
        speedIndexFilter: null,
        speedIndexFilterGreater: false,
        loadIndexFilter: null,
        loadIndexFilterGreater: false,
        runFlatFilter: null,
        skus: null,
        currentPage: 1,
        totalPages: 1,
        totalResults: 0
    }

    if (address) {
        res.salutation = address.salutation;
        res.firstName = address.firstName;
        res.lastName = address.lastName;
        res.companyName = address.companyName;
        res.street = address.street;
        res.streetNumber = address.streetNumber;
        res.addressLine2 = address.addressLine2;
        res.zipcode = address.zipcode;
        res.city = address.city;
        res.countryCode = address.countryCode;
        res.phone = address.phone;
        res.emailAddress = address.emailAddress;
    }

    let params = (new URL(document.location)).searchParams;
    let preselectStationId = Number(params.get("stn"));
    if (preselectStationId && !isNaN(preselectStationId) && settings.AvailableStations.find(s => s.id == preselectStationId) !== undefined) {
        res.selectedStationId = preselectStationId;
    }

    return res;
}

const getters = {
    address: state => {
        return {
            salutation: state.salutation,
            firstName: state.firstName,
            lastName: state.lastName,
            companyName: state.companyName,
            street: state.street,
            streetNumber: state.streetNumber,
            addressLine2: state.addressLine2,
            zipcode: state.zipcode,
            city: state.city,
            countryCode: state.countryCode,
            phone: state.phone,
            emailAddress: state.emailAddress
        };
    },
    mwstIncludedText: state => {
        return state.strings['PneuOffer.IncludingMwst'];
    }
}

const actions = {}

const mutations = {
    setSelectedStationId(state, id) {
        state.selectedStationId = id;
    },
    setSelectedTyre(state, tyre) {
        state.selectedTyre = tyre;
    },
    setTyreAmount(state, newAmount) {
        state.tyreAmount = newAmount;
    },
    setRimType(state, newType) {
        state.rimType = newType;
    },
    setCarType(state, newType) {
        state.carType = newType;
    },
    setRemarks(state, newRemarks) {
        state.remarks = newRemarks;
    },
    setDseAccepted(state, newStatus) {
        state.dseAccepted = newStatus;
    },
    setAddress(state, newAddress) {
        state.salutation = newAddress.salutation;
        state.firstName = newAddress.firstName;
        state.lastName = newAddress.lastName;
        state.companyName = newAddress.companyName;
        state.street = newAddress.street;
        state.streetNumber = newAddress.streetNumber;
        state.addressLine2 = newAddress.addressLine2;
        state.zipcode = newAddress.zipcode;
        state.city = newAddress.city;
        state.countryCode = newAddress.countryCode;
        state.phone = newAddress.phone;
        state.emailAddress = newAddress.emailAddress;
    },

    //step 1 mutations
    setSeasonFilter(state, newVal) { state.seasonFilter = newVal; },
    setWidthFilter(state, newVal) { state.widthFilter = newVal; },
    setHeightFilter(state, newVal) { state.heightFilter = newVal; },
    setRimSizeFilter(state, newVal) { state.rimSizeFilter = newVal; },
    setBrandFilter(state, newVal) { state.brandFilter = newVal; },
    setSpeedIndexFilter(state, newVal) { state.speedIndexFilter = newVal; },
    setSpeedIndexFilterGreater(state, newVal) { state.speedIndexFilterGreater = newVal; },
    setLoadIndexFilter(state, newVal) { state.loadIndexFilter = newVal; },
    setLoadIndexFilterGreater(state, newVal) { state.loadIndexFilterGreater = newVal; },
    setRunFlatFilter(state, newVal) { state.runFlatFilter = newVal; },
    setSkus(state, newVal) { state.skus = newVal; },
    setCurrentPage(state, newVal) { state.currentPage = newVal; },
    setTotalPages(state, newVal) { state.totalPages = newVal; },
    setTotalResults(state, newVal) { state.totalResults = newVal; }
}

export default async function createStore(addresses, strings, params, enums, settings, confirmationText, images) {

    let store = new Vuex.Store({
        state: createState(addresses, strings, params, enums, settings, confirmationText, images),
        getters,
        actions,
        mutations,
        strict: true
    });

    return store;
}